import { createContext, useContext } from 'react';

//THIS IS FOR MAINITAING THE LEFT MENU THINGS AS GLOBAL PROPS
export const LeftMenuContext = createContext({
  menuExpanded: false, //FOR STORING THE MENU EXPANDED VALUE
  selectedMenu: '', //FOR STORING THE SELECTED MENU NAME
  setSelectedMenu: () => { } //FOR CHANGING THE SELECTED MENU NAME VIA SET STATE
});

export const useLeftMenuContext = () => useContext(LeftMenuContext);